import * as React from "react";
import SecondaryButton from "@/components/secondary-button";

export default function SidebarBoxAction({
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <SecondaryButton {...props}>{children}</SecondaryButton>;
}
